<script>
export default {
  name: 'LineUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#386C4D',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue
    // durante a vida da app). O id fixo original (copiado de export do Figma)
    // colide quando o mesmo ícone renderiza mais de uma vez na mesma página,
    // invalidando o clip-path nas instâncias duplicadas.
    clipId() {
      return `clip0_2750_28940_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g :clip-path="`url(#${clipId})`">
      <path
        d="M2 11.3334L6 7.33341L8.66667 10.0001L14 4.66675"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33331 4.66675H14V9.33341"
        :stroke="color"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath :id="clipId">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
